import React, { PropsWithChildren } from 'react';
import { DivProps } from '../../../../types/HtmlProps';
import { appendClassName } from '../../../../lib/bemUtils/classname';
import { AccordionPanelModifier } from './Accordion.modifier';
import Bem from '../../../../lib/bemUtils/bem';

interface AccordionPanelProps extends DivProps {
  modifier?: AccordionPanelModifier;
}

export function AccordionPanel({
  children,
  className,
  modifier,
  role,
  ...divProps
}: PropsWithChildren<AccordionPanelProps>) {
  return (
    <div
      {...divProps}
      className={appendClassName(className, Bem('accordion__panel', modifier))}
      role={role || 'region'}
    >
      <div className="accordion__panel-content">{children}</div>
    </div>
  );
}
